import { CardCvcElement, CardExpiryElement, CardNumberElement, useElements, useStripe } from '@stripe/react-stripe-js'
import { useState } from 'react'

import ErrorWrapper from '../../components/ErrorWrapper'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { bankService } from '../../_services'
import { toast } from 'react-toastify'
const validationSchema = Yup.object({})


export function AddBankCardForm({ onClose, setRefreshKey }) {
    const stripe = useStripe()
    const elements = useElements()
    const [errors, setErrors] = useState({})

    const initialValue = {
        cardNumber: '',
        cvv: '',
        expiryDate: '',
        holdername: '',
    }
    const [isCardAddingInProgress, setIsCardAddingInProgress] = useState(false)
    const [name, setName] = useState('')

    const handleNewAdd = async (e) => {
        if (!stripe || !elements) {
            return
        }

        try {
            setIsCardAddingInProgress(true)
            const cardElement = elements.getElement(CardNumberElement)

            const { error } = await stripe.createToken(cardElement)
            if (name.trim().length === 0) {
                setErrors((prev) => ({ ...prev, name: 'Card holder name is required.' }))
            }
            if (error) {
                let er = {}
                if (error.type === 'validation_error') {
                    if (error.code === 'incomplete_number') {
                        er['cardNumber'] = error.message
                    }
                    if (error.code === 'invalid_expiry_year_past' || error.code === 'exp_year') {
                        er['cardExpiry'] = error.message
                    }
                    if (error.code === 'incomplete_cvc') {
                        er['cardCvc'] = error.message
                    }
                    setErrors((prev) => ({ ...prev, ...er }))
                }

                setIsCardAddingInProgress(false)
                return
            }
            if (!error && name.length > 0) {
                const { token } = await stripe.createToken(cardElement, { name })
                const res = await bankService.addNewCard(token)

                if (res.status) {
                    toast.success(res.message, { toastId: 'card-added' })
                } else toast.error(res.message)
                onClose()
                setRefreshKey((e) => e + 1)
                setIsCardAddingInProgress(false)
            }
        } catch (error) {
            setIsCardAddingInProgress(false)
            toast.error('Something went wrong!')
        } finally {
            setIsCardAddingInProgress(false)
        }
    }

    return (
        <div className="tw-bg-white md:tw-rounded-md md:tw-p-4">
            <div className="modal-body">
                <Formik validationSchema={validationSchema} initialValues={initialValue} onSubmit={handleNewAdd}>
                    {() => {
                        return (
                            <Form className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-2 tw-space-y-2">
                                    <h3 className="tw-text-xl tw-mb-4">Add Credit Card</h3>
                                <div className="md:tw-col-span-2 ">
                                    <label className="text-label form-label" htmlFor="address-1">
                                        Card Number
                                    </label>
                                    <CardNumberElement
                                        
                                        onChange={(e) => {
                                            if (e) {
                                                if (e.empty) {
                                                    setErrors((prev) => ({ ...prev, [e.elementType]: 'Card number is required.' }))
                                                } else if (e.error) {
                                                    setErrors((prev) => ({ ...prev, [e.elementType]: e.error.message }))
                                                } else if (e.complete) {
                                                    setErrors((prev) => ({ ...prev, [e.elementType]: null }))
                                                }
                                            }
                                        }}
                                        className="tw-overflow-hidden tw-h-10 form-control tw-p-3"
                                    />
                                    <div className="tw-mt-1">{errors && errors.cardNumber && <ErrorWrapper>{errors.cardNumber}</ErrorWrapper>}</div>
                                </div>
                                <div>
                                    <label className="text-label form-label " htmlFor="expiry-date">
                                        Expiration Date
                                    </label>
                                    <CardExpiryElement
                                        onChange={(e) => {
                                            if (e) {
                                                if (e.empty) {
                                                    setErrors((prev) => ({ ...prev, [e.elementType]: 'Card expiration date is required.' }))
                                                } else if (e.error) {
                                                    setErrors((prev) => ({ ...prev, [e.elementType]: e.error.message }))
                                                } else if (e.complete) {
                                                    setErrors((prev) => ({ ...prev, [e.elementType]: null }))
                                                }
                                            }
                                        }}
                                        className="tw-overflow-hidden tw-h-10 form-control tw-p-3"
                                    />
                                    <div className="tw-mt-1">{errors && errors.cardExpiry && <ErrorWrapper>{errors.cardExpiry}</ErrorWrapper>}</div>
                                </div>
                                <div>
                                    <label className="text-label form-label " htmlFor="cvv">
                                        CVV
                                    </label>

                                    <CardCvcElement
                                        options={{ placeholder: 'CVV' }}
                                        onChange={(e) => {
                                            if (e) {
                                                if (e.empty) {
                                                    setErrors((prev) => ({ ...prev, [e.elementType]: 'Card CVV is required.' }))
                                                } else if (e.error) {
                                                    setErrors((prev) => ({ ...prev, [e.elementType]: e.error.message }))
                                                } else if (e.complete) {
                                                    setErrors((prev) => ({ ...prev, [e.elementType]: null }))
                                                }
                                            }
                                        }}
                                        className="tw-overflow-hidden tw-h-10 form-control tw-p-3"
                                    />
                                    <div className="tw-mt-1">{errors && errors.cardCvc && <ErrorWrapper>{errors.cardCvc}</ErrorWrapper>}</div>
                                </div>
                                <div className="md:tw-col-span-2">
                                    <label className="text-label form-label " htmlFor="card-holder-name">
                                        Card Holder Name
                                    </label>
                                    <input
                                        name="holderName"
                                        type="text"
                                        value={name}
                                        onChange={(e) => {
                                            setName(e.target.value)
                                            if (name.trim().length > 0) {
                                                errors.name = ''
                                            }
                                        }}
                                        placeholder="Exact name on credit card"
                                        className="form-control "
                                    />
                                    <div className="tw-mt-1">{errors && errors.name && <ErrorWrapper>{errors.name}</ErrorWrapper>}</div>
                                </div>

                                
                                
                                <div className="tw-flex tw-gap-2">
                                    <button onClick={onClose} type="button" className="btn btn-secondary mb-3  ">
                                        Cancel
                                    </button>
                                    <button disabled={isCardAddingInProgress} type="submit" className="btn btn-primary mb-3  ">
                                        {isCardAddingInProgress ? 'Please wait ...' : 'Submit'}
                                    </button>
                                </div>
                            </Form>
                        )
                    }}
                </Formik>
            </div>
        </div>
    )
}